import { AditionConfig } from "./interfaces";

export const CONFIG_ENVIRONMENT = 'REPLACE:CONFIG_ENVIRONMENT';
export const CONFIG_PENPAL_CONNECTION_TIMEOUT = 3000;

// Default Permission Client config.
export const CONFIG_STORAGE_KEY = 'UI_CMP_PERMISSION_DATA';
export const CONFIG_PERMISSION_CORE_URL = 'REPLACE:CONFIG_PERMISSION_CORE_URL';
export const CONFIG_LAYER_DEFAULT_CLASSNAME = 'permission-layer-default';
export const CONFIG_CORE_IFRAME_CLASSNAME = 'permission-core-iframe';

// ADITION Config
export const CONFIG_ADITION: AditionConfig = {
    PRF_PARAM_PREFIX: {
        CONSENT: 'c',
        CONSENT_PARAMETER: 'cp'
    },
    DEFAULT: {
        TAGID: 'permission',
        LAYOUTCLASS: 'b',
        REQUEST_TYPE: 'x',
        NETWORK: '42',
        ENDPOINT: 'REPLACE:CONFIG_ADITION_BASE_URL'
    },
    ENDPOINT: {
        'webde': 'https://plus.web.de',
        'gmx': 'https://plus.gmx.net',
        'gmxat': 'https://plus.gmx.at',
        'gmxch': 'https://plus.gmx.ch',
        'gmxes': 'https://plus.gmx.net',
        'gmxfr': 'https://plus.gmx.net',
        'gmxcom': 'https://plus.gmx.net',
        'mailcom': 'https://plus.gmx.net',
        '1und1': 'https://plus.gmx.net'
    }
};

// Not (yet) used
//export const CONFIG_PERMISSION_CENTER_WRITE_HEADER: string 			= 'application/vnd.mf.pmc.permission-v1+json';
//export const CONFIG_PERMISSION_CENTER_READ_URL: string				= 'http://localhost:8010/pmc/';
//export const CONFIG_PERMISSION_CENTER_READ_HEADER: string 			= 'application/vnd.mf.pmc.permission.list-v1+json';
//export const CONFIG_PERMISSION_CENTER_WRITE_URL: string				= 'http://localhost:8010/pmc/identity_types/1/identities/8013859303/permission_status;valid=false';
